import { createFileRoute } from '@tanstack/react-router';
import { RolesSettingsPage } from '../features/settings/access/RolesSettingsPage';

export const Route = createFileRoute('/settings/roles')({
  component: RolesSettingsPage,
});
